import React from 'react';
import { Container, Text } from '@uncinc/uncinc-react-kitchen-sink';
import c from 'classnames';

import { ParagraphTextEmbed as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

export interface ParagraphTextEmbedProps extends React.HTMLProps<HTMLDivElement> {
  entity: {
    toJS: () => Type;
  };
}

const ParagraphTextEmbed: React.FC<ParagraphTextEmbedProps> = ({ entity }) => {
  const paragraph = entity.toJS();
  const title = paragraph.field_title?.[0]?.value;
  const body = paragraph.field_body?.[0]?.processed ?? '';
  const social = paragraph.field_socialmedia_post[0];
  const postUrl = social?.entity.field_media_oembed_main_bucket[0]?.value;
  const embedUrl = toTikTokEmbedUrl(postUrl ?? '');

  const classNames = c('Paragraph', 'ParagraphTextEmbed');

  return (
    <div className={classNames}>
      <Container>
        <div className="row">
          <div className="col-12 col-lg-6">
            <div className="ParagraphTextEmbed__body-wrapper">
              <div className="ParagraphTextEmbed__body">
                <Text
                  title={title}
                  text={body}
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="ParagraphTextEmbed__media-wrapper">
              <iframe
                src={embedUrl}
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                {...{ title }}
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

function toTikTokEmbedUrl(url: string): string | undefined {
  const match = url.match(/video\/(\d+)/);
  if (!match || !match[1]) return undefined;
  return `https://www.tiktok.com/embed/${match[1]}`;
}

export default ParagraphTextEmbed;
